'use client';

import React, { useState, useEffect } from 'react';
import Link from 'next/link';
import AppLogo from '@/components/ui/AppLogo';

export default function LandingNav() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-card/95 backdrop-blur-md border-b border-border card-shadow' : 'bg-transparent'
      }`}
    >
      <div className="max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link href="/" className="flex items-center gap-2">
            <AppLogo size={32} />
            <span className="font-bold text-xl text-foreground tracking-tight">BioLink</span>
          </Link>

          {/* Desktop nav */}
          <div className="hidden md:flex items-center gap-8">
            {[
              { label: 'Features', href: '#features' },
              { label: 'Templates', href: '#templates' },
              { label: 'Pricing', href: '#pricing' },
            ]?.map((item) => (
              <a
                key={`nav-${item?.label}`}
                href={item?.href}
                className="text-sm font-500 text-muted-foreground hover:text-foreground transition-colors"
              >
                {item?.label}
              </a>
            ))}
          </div>

          {/* CTAs */}
          <div className="hidden md:flex items-center gap-3">
            <Link
              href="/sign-up-login-screen"
              className="text-sm font-500 text-muted-foreground hover:text-foreground transition-colors px-4 py-2"
            >
              Sign in
            </Link>
            <Link
              href="/sign-up-login-screen"
              className="btn-primary text-sm font-600 px-5 py-2.5 rounded-xl"
            >
              Create Free Bio Page
            </Link>
          </div>

          {/* Mobile hamburger */}
          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden p-2 rounded-lg hover:bg-muted transition-colors"
            aria-label="Toggle menu"
          >
            {mobileOpen ? (
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            ) : (
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            )}
          </button>
        </div>

        {/* Mobile menu */}
        {mobileOpen && (
          <div className="md:hidden bg-card border-b border-border pb-4 animate-fade-in">
            <div className="flex flex-col gap-1 pt-2">
              {[
                { label: 'Features', href: '#features' },
                { label: 'Templates', href: '#templates' },
                { label: 'Pricing', href: '#pricing' },
              ]?.map((item) => (
                <a
                  key={`mobile-nav-${item?.label}`}
                  href={item?.href}
                  className="px-4 py-3 text-sm font-500 text-muted-foreground hover:text-foreground hover:bg-muted rounded-lg transition-colors"
                  onClick={() => setMobileOpen(false)}
                >
                  {item?.label}
                </a>
              ))}
              <div className="border-t border-border mt-2 pt-3 px-4 flex flex-col gap-2">
                <Link href="/sign-up-login-screen" className="text-sm font-500 text-center py-2.5 rounded-xl border border-border hover:bg-muted transition-colors">
                  Sign in
                </Link>
                <Link href="/sign-up-login-screen" className="btn-primary text-sm font-600 text-center py-2.5 rounded-xl">
                  Create Free Bio Page
                </Link>
              </div>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}